import { Navigate, Outlet } from "react-router-dom";
import { isAdminAuthenticated } from "@/libs/auth";
import Sidebar from "@/components/layout/Sidebar";

export default function AuthLayout() {
  if (!isAdminAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="flex w-full min-h-screen">
      <Sidebar />
      <div className="flex-1 ml-[60px]">
        <Outlet />
      </div>
    </div>
  );
}
